<template>
  <div class="col-md-8 offset-md-2">
    <h2 class="text-center">Вы выбрали:</h2>
    <hr>
    <div class="row" v-if="cart.length > 0" v-for="product in cart" :key="product.id">
      <div class="col-md-2" style="max-height:70px; overflow-y:hidden;"><img width="100%" :src="config.url + config.img_url + config.id + '/' + product.image"
          alt=""></div>
      <div class="col-md-5" style="padding-top: 20px;">
        <p style="font-family: Akrobat-SemiBold !important; font-size:20px;">{{ product.name }}</p>
      </div>
      <div class="col-md-2" style="padding-top: 25px; font-size: 16px;">
        <i class="fa cursor fa-minus-circle" @click="dec(product.id)"></i>
        <span>{{ qtyInCart(product.id) }} шт.</span>
        <i class="fa fa-plus-circle cursor" @click="inc(product.id)"></i></div>
      <div class="col-md-2" style="padding-top: 25px; font-size: 16px;">
        <p>{{ product.price * product.qty }} <i class="fa fa-ruble-sign"></i></p>
      </div>
      <div class="col-md-1" style="padding-top: 25px; font-size: 24px;"><i class="fa cursor fa-window-close" @click="del(product.id)"></i></div>
      <div class="col-md-12">
        <hr>
      </div>
    </div>
    <div class="col-md-12 text-right">
      <h3 v-if="total_in_cart != total_price">Стоимость заказа: {{ total_in_cart }} <i class="fa fa-ruble-sign"></i></h3>
      <h3 v-if="orderProp.sale">Скидка: {{ orderProp.sale }} <i class="fa fa-percent"></i></h3>
      <h3 v-if="orderProp.margin"> {{ orderProp.margin.name}}: {{ orderProp.margin.margin }} <i class="fa fa-ruble-sign"></i></h3>
      <h3 v-if="orderProp.min_price && orderProp.min_price > total_in_cart">Минимальная сумма заказа: {{ orderProp.min_price }} <i class="fa fa-ruble-sign"></i></h3>
      <h3>Итого: {{ total_price }} <i class="fa fa-ruble-sign"></i></h3>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      config() {
        return this.$store.state.config;
      },
      orderProp() {
        return this.$store.state.orderProp;
      },
      cart() {
        return this.$store.state.cart;
      },
      total_in_cart() {
        return _.sumBy(this.cart, function (product) {
          return product.price * product.qty;
        });
      },
      total_price() {
        var vm = this;
        var price = vm.total_in_cart;
        if (vm.orderProp.sale) {
          if (vm.orderProp.sale == 0) {
            return price;
          } else {
            return price - (price / 100 * vm.orderProp.sale);
          }
        } else if (vm.orderProp.margin) {
          return parseInt(price, 10) + parseInt(vm.orderProp.margin.margin, 10);
        } else {
          return price;
        }
      },
    },
    methods: {
      qtyInCart(id) {
        var found = _.find(this.$store.state.cart, ["id", id]);
        if (typeof found == "object") {
          return found.qty;
        } else {
          return 0;
        }
      },
      inc(id) {
        this.$store.commit({
          type: "inc",
          id
        });
      },
      dec(id) {
        this.$store.commit({
          type: "dec",
          id
        });
      },
      del(id) {
        this.$store.commit({
          type: "del",
          id
        });
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Order/cart.vue